"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQuestIconRecolors = void 0;
const retrommo_types_1 = require("retrommo-types");
const QuestState_1 = require("../types/QuestState");
const getQuestPartyState_1 = require("./getQuestPartyState");
const getQuestState_1 = require("./getQuestState");
const getQuestIconRecolors = (questID, usePartyState) => {
    let toColor;
    switch (usePartyState ? (0, getQuestPartyState_1.getQuestPartyState)(questID) : (0, getQuestState_1.getQuestState)(questID)) {
        case QuestState_1.QuestState.InProgress:
            toColor = retrommo_types_1.Color.DarkGray;
            break;
        case QuestState_1.QuestState.TurnIn:
            toColor = retrommo_types_1.Color.StrongLimeGreen;
            break;
    }
    if (typeof toColor === "undefined") {
        throw new Error("No recolor found for quest state.");
    }
    return [
        {
            fromColor: retrommo_types_1.Color.White,
            toColor,
        },
    ];
};
exports.getQuestIconRecolors = getQuestIconRecolors;
